import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Init',
      component: () => import('@/views/Init.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/list',
      name: 'ConversationList',
      component: () => import('@/views/ConversationList.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/chat/:conversationID',
      name: 'Chat',
      component: () => import('@/views/Chat.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/call',
      name: 'VideoCall',
      component: () => import('@/views/VideoCall.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: () => import('@/views/Agreement.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/error',
      name: 'Error',
      component: () => import('@/views/Error.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})

// 路由守卫：需要认证且无 token → 回到 Init
router.beforeEach((to) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('h5im_token')
    if (!token) {
      return { name: 'Init' }
    }
  }
})

export default router
